// extracted by mini-css-extract-plugin
module.exports = {"Search":"styles_Search__1Po_c"};